import React, { Fragment, useContext } from "react";
import { BrowserRouter } from "react-router-dom";
import { UserContext, UserContextProvider } from "./context/userContext";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { ThemeProvider, StyledEngineProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import AAAppBar from "./components/AAAppBar";
import MainPage from "./pages/MainPage";
import LoginDialog from "./dialogs/LoginDialog";
import PostLoginResetDialog from "./dialogs/PostLoginResetDialog";
import { env } from "./env";

function AppContent() {
  const { showResetPasswordDialog, updateShowResetPasswordDialog } = useContext(UserContext);

  return (
    <Fragment>
      <div style={{ display: "flex" }}>
        <CssBaseline />
        <AAAppBar />
        <MainPage />
      </div>

      <LoginDialog
        title="Idox ADS Security Login"
        message="Please enter your username and password."
        version={env.REACT_APP_SECURITY_VERSION || "1"}
        />

      {showResetPasswordDialog && (
        <PostLoginResetDialog onClose={() => updateShowResetPasswordDialog(false)} />
      )}
    </Fragment>
  );
}

function App() {
  const theme = createTheme();

  return (
    <UserContextProvider>
      <BrowserRouter>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <AppContent />
            </LocalizationProvider>
          </ThemeProvider>
        </StyledEngineProvider>
      </BrowserRouter>
    </UserContextProvider>
  );
}

export default App;
